module.exports = {
  "$id": "securityOrder",
  "type": "object",
  "title": "安全验证",
  "properties": {
    "fullName": {
      "title": "乘机人",
      "type": "string"
    },
    "departure": {
      "title": "出发城市",
      "type": "string"
    },
    "arrival": {
      "title": "到达城市",
      "type": "string"
    }
  },
  "required": [
    "fullName",
    "departure",
    "arrival"
  ],
  "errorMessage": {
    "fullName": {
      "required": "请输入乘机人姓名"
    },
    "departure": {
      "required": "请输入出发城市"
    },
    "arrival": {
      "required": "请输入到达城市"
    }
  }
}
